module.exports = __webpack_public_path__ + "static/media/class_small_rogue.a1f42042.png";